<template>
	<v-container wrap v-if="!inEquipmentEditMode">
		<v-row>
			<v-col v-for="(inspection, index) in items" :key="index" cols="12">
				<v-card flat outlined class="pa-2" :class="{ 'red-border': isDueAndNotClosed(inspection) }">
					<v-row>
						<v-col cols="12" v-if="!inspection.closed && $myStore.state.user.user_role_id == 1">
							<v-row justify="end">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn depressed icon v-bind="attrs" @click="editClick(inspection)" v-on="on">
											<v-icon small class="pr-2">fa-edit</v-icon>
										</v-btn>
									</template>
									<span>{{ $t('tooltips.editInspection') }}</span>
								</v-tooltip>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											depressed
											icon
											v-bind="attrs"
											@click="deleteClick(inspection.id)"
											v-on="on"
										>
											<v-icon small class="pr-2">fa-trash</v-icon>
										</v-btn>
									</template>
									<span>{{ $t('tooltips.deleteInspection') }}</span>
								</v-tooltip>
							</v-row>
						</v-col>
						<v-col>
							<Inspection :inspection="inspection" :inEditMode="false"> </Inspection>
						</v-col>
						<v-col cols="12" v-if="!inspection.closed && $myStore.state.user.user_role_id == 1">
							<v-row justify="center">
								<v-btn @click="closeInspection(inspection)">{{ $t('buttons.close') }}</v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col class="d-flex justify-center pa-8" cols="12" v-if="showLoadClosedInspectionsBtn">
				<v-btn @click="loadClosedInspections()">{{ $t('buttons.loadClosedInspections') }}</v-btn>
			</v-col>
			<v-col cols="12" v-else>
				<div :class="['text-h6', 'pa-4', 'text-center']">
					{{ $t('titles.closedInspections') }}
				</div>
			</v-col>
			<v-col cols="12" class="text-center" v-if="closedInspections.length === 0 && !showLoadClosedInspectionsBtn">
				<div :class="['text-subtitle-1', 'pa-4', 'text-center']">
					{{ $t('titles.noClosedInspections') }}
				</div>
			</v-col>
			<v-row v-if="!showLoadClosedInspectionsBtn">
				<v-col v-for="(inspection, index) in closedInspections" :key="index" cols="12">
					<v-card flat outlined class="pa-2">
						<v-row>
							<v-col>
								<Inspection :inspection="inspection" :inEditMode="false"> </Inspection>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</v-row>
		<v-row>
			<v-col>
				<Modal :show-modal="showModal">
					<Inspection
						:inspection="selectedInspection"
						:closingInspection="closingInspection"
						:inEditMode="editMode"
						@close="closeModal"
					></Inspection>
				</Modal>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Inspection from './Inspection';
import Modal from '../../trinkets/Modal';

export default {
	name: 'Inspections',
	components: { Inspection, Modal },
	props: {
		value: [Number, String],
		equipmentId: [Number, String],
		inEquipmentEditMode: Boolean,
	},
	data() {
		return {
			items: [],
			closedInspections: [],
			showModal: false,
			selectedInspection: null,
			editMode: false,
			closingInspection: false,
			showLoadClosedInspectionsBtn: true,
		};
	},
	mounted() {
		let vm = this;
		this.reloadData();
		this.$modalBus.$on('reloadInspections', () => {
			vm.reloadData();
		});
	},

	methods: {
		openModal() {
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
			this.closingInspection = false;
			this.selectedInspection = {};
		},
		isDueAndNotClosed(inspection) {
			const today = new Date();
			const dueDate = new Date(inspection.due_date);
			return !inspection.closed && dueDate <= today;
		},
		deleteClick(id) {
			let vm = this;
			this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
				if (result) {
					vm.$APICall(
						'delete',
						'inspection/' + id + '/delete',
						{ equipment_id: this.equipmentId, id: id },
						(data, success) => {
							if (success) {
								vm.$notify(vm.$t('alerts.inspectionDeleteSuccess'));
								vm.reloadData();
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						}
					);
				}
			});
		},
		loadClosedInspections() {
			let vm = this;
			let closed = true;
			this.$APICall(
				'get',
				'inspections/' + this.equipmentId,
				{ closed },
				(data, success) => {
					if (success) {
						vm.closedInspections = data.items;
						vm.showLoadClosedInspectionsBtn = false;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		reloadData() {
			let vm = this;
			let closed = false;
			this.$APICall(
				'get',
				'inspections/' + this.equipmentId,
				{ closed },
				(data, success) => {
					if (success) {
						vm.items = data.items;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
					vm.showLoadClosedInspectionsBtn = true;
				},
				false
			);
		},
		editClick(inspection) {
			this.selectedInspection = { ...inspection };
			this.editMode = true;
			this.openModal();
		},

		closeInspection(inspection) {
			this.selectedInspection = { ...inspection };
			this.closingInspection = true;
			this.editMode = false;
			this.openModal();
		},
	},
};
</script>
<style scoped>
.red-border {
	border: 2px solid red;
}
</style>
